<template>
  <div>
    <div class="page-modal">
      <gs-modal
        v-model="visible"
        :before-close="beforeClose"
        class="my-test-class"
        title="添加节点"
        @close="close"
        @confirm="handleConfirm"
      >
        <gs-select />
      </gs-modal>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
export default {
  components: {

  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState({
      visible: 'dialogShow'
    })
  },
  watch: {
  },
  created () {

  },
  mounted () {

  },
  methods: {
    ...mapMutations({
      close: 'DIALOG_HIDE'
    }),
    beforeClose () {
      this.close()
    },
    handleConfirm () {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/easy-point/point-add.vue